{
    "Accessibility menu": "תפריט נגישות",
    "Close": "סגור",
    "Content adjustments": "התאמות תוכן",
    "Navigation adjustments": "התאמות ניווט",
    "Text Align": "יישור טקסט",
    "Align Left": "יישור לשמאל",
    "Align Center": "יישור למרכז",
    "Align Right": "יישור לימין",
    "Adjust Font Size": "התאם גודל פונט",
    "Highlight Title": "הדגש כותרת",
    "Highlight Links": "הדגש קישורים",
    "Readable Font": "פונט קריא",
    "Colour adjustments": "התאמות צבע",
    "Dark Contrast": "ניגודיות כהה",
    "Light Contrast": "ניגודיות בהירה",
    "High Contrast": "ניגודיות גבוהה",
    "High Saturation": "רוויה גבוהה",
    "Low Saturation": "רוויה נמוכה",
    "Monochrome": "מונוכרום",
    "Tools": "כלים",
    "Reading Guide": "מדריך קריאה",
    "Big Cursor": "סמן גדול",
    "Increase Font Size": "הגדל גודל פונט",
    "Decrease Font Size": "הקטן גודל פונט",
    "Letter Spacing": "מרווח בין אותיות",
    "Line Height": "גובה שורה",
    "Font Weight": "משקל הפונט",
    "Dyslexia Font": "פונט לדיסלקטים",
    "Language": "שפה",
    "Accessibility widget": "פתח תפריט נגישות",
    "Accessibility Profiles": "פרופילי נגישות",
    "Cognitive Disability": "מוגבלות קוגניטיבית",
    "Seizure Safe": "בטוח מפני התקפים",
    "Accessibility statement": "הצהרת נגישות",
    "ADHD": "הפרעת קשב וריכוז",
    "Low Vision": "ראייה לקויה",
    "Pause Animations": "עצירת אנימציות",
    "Animation paused": "האנימציה הושהתה",
    "Reset all settings": "איפוס הגדרות",
    "Shortcut:": "קיצור מקלדת:",
    "Epilepsy Safe Mode": "מצב בטוח לאפילפסיה",
    "Mute sounds": "השתקת צלילים",
    "Page read": "הקראת העמוד",
    "Page read controls": "פקדי הקראת העמוד",
    "Pause": "השהיה",
    "Resume": "המשך",
    "Stop": "עצירה",
    "Settings": "הגדרות",
    "Speed": "מהירות",
    "Voice": "קול",
    "Close accessibility menu": "סגירת תפריט הנגישות",
    "Back to accessibility menu": "חזרה לתפריט הנגישות",
    "Search languages": "חיפוש שפות",
    "Selected language": "השפה הנבחרת",
    "View accessibility statement (opens in new window)": "הצגת הצהרת הנגישות (נפתח בחלון חדש)",
    "Visit CookieYes website (opens in new window)": "מעבר לאתר CookieYes (נפתח בחלון חדש)",
    "Reset all accessibility settings to default": "איפוס כל הגדרות הנגישות לברירת המחדל"
}
